import { BoneModal } from './BoneModal';

const rootClass = 'search-bar';
const modalId = 'search-overlay';

const SearchBar = (() => {

	const sb = {
		root: undefined,
		modal: undefined,
		hasModal: false,
	};

	sb.init = function() {
		const root = document.querySelector(`.${rootClass}`);
		if (!root) {
			return;
		}

		sb.root = root;

		const modalElem = document.getElementById(modalId);
		if (modalElem) {
			sb.modal = new BoneModal(modalElem, {
				onOpen: sb.setFocusToSearchInput,
			});
			sb.hasModal = true;
		}

		sb._setupNavigationDelegate();
	}

	sb._setupNavigationDelegate = function() {
		sb.root.addEventListener('click', sb.onRequestNavigation, {passive: true});
	}

	sb.onRequestNavigation = function(e) {
		const clickTarget = e.target;
		const formSubmit = clickTarget.closest('[type="submit"]');
		const anchor = clickTarget.closest('a'); // should this be more specific??

		if (formSubmit) {
			clickTarget.preventDefault();
		}
		else if (anchor) {
			//
		}
		else {
			return;
		}

		sb.closeModal();
		sb.clearInput();
	}

	sb.setFocusToSearchInput  = function() {
		const input = sb.root.querySelector('input[type="search"]');
		if (!input) {
			return;
		}

		input.focus();
	}

	sb.closeModal = function() {
		if (sb.hasModal) {
			sb.modal.close();
		}
	}

	sb.clearInput = function() {
		const input = sb.root.querySelector('input[type="search"]');
		if (input) {
			input.value = '';
		}
	}


	return sb;

})();


export default SearchBar;



// WEBPACK FOOTER //
// ./scripts/modules/search-bar.js